package amazon.lastmile.inject

import app.nestbridge.feature.children.ui.ChildDetailUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = ChildDetailUiFactory::class)
public interface AppNestbridgeFeatureChildrenUiChildDetailUiFactory {
  @Provides
  @IntoSet
  public fun provideChildDetailUiFactoryFactoryMultibinding(childDetailUiFactory: ChildDetailUiFactory): Ui.Factory = childDetailUiFactory
}
